import { Chord, Note } from 'tonal';
import { getNoteNameFromCoord, formatNoteWithOctavePrefix, D_REF_MIDI } from './keyboard-layouts';
export function coordToNoteName(x: number, y: number, octaveOffset = 0): string {
  const midi = D_REF_MIDI + x * 7 + y * 12 + octaveOffset * 12;
  return formatNoteWithOctavePrefix(midi);
}
export function midiToNoteName(midi: number): string {
  return formatNoteWithOctavePrefix(midi);
}
export function detectChord(coords: [number, number, number][]): string[] {
  if (coords.length < 2) return [];

  const noteNames = coords.map(([x, _y, _oct]) => getNoteNameFromCoord(x));

  const uniqueNotes = [...new Set(noteNames)];

  if (uniqueNotes.length < 2) return [];

  try {
    const detected = Chord.detect(uniqueNotes, { assumePerfectFifth: true });

    return detected.map(chord => chord.replace(/M($|(?=\/))/g, ''));
  } catch {
    return [];
  }
}
export function getActiveNoteNames(coords: [number, number, number][]): string[] {
  return coords
    .map(([x, y, oct]) => coordToNoteName(x, y, oct))
    .sort((a, b) => {
      const midiA = Note.midi(a) ?? 0;
      const midiB = Note.midi(b) ?? 0;
      return midiA - midiB;
    });
}
